import React, { useContext, useState } from 'react';
import {
  RadioGroupField,
  SelectField
} from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';

import Heading from '../../components/Typography/Heading/Heading';
import SubHeading from '../../components/Typography/SubHeading/SubHeading';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import {
  accountPathTypes,
  newAccountProductTypeOptions,
  displayAccountTypeOptions,
  displayProductTypeOptions,
  redirectToFONASU,
  displayAdditionalText
} from './utils';
import styles from './MFAccountFinderScreen.css';
import { getCookie } from '../../core/util';

const MFAccountFinderScreen = () => {
  const { formProps } = useContext(FlowContext);
  const bpId = getCookie('bpId');

  const [isProductTypeSelected, setIsProductTypeSelected] = useState(false);
  const [isAccountTypeSelected, setIsAccountTypeSelected] = useState(false);

  const [accountPathType, setAccountPathType] = useState(
    accountPathTypes.NEW_ACCOUNT
  );
  const [productTypeOption, setProductTypeOption] = useState('');
  const [productTypeOptions, setProductTypeOptions] = useState(
    newAccountProductTypeOptions
  );
  const [accountTypeOption, setAccountTypeOption] = useState('');
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);

  const handleAccountOption = ({ target: { value } }) => {
    const availableProductOptions = displayProductTypeOptions(value);
    setAccountPathType(value);
    const availableAccountOptions = displayAccountTypeOptions(
      value,
      productTypeOption
    );

    setAccountTypeOptions(availableAccountOptions);

    // set product type and account type selected to false when radio options are changed
    setIsProductTypeSelected(false);
    setIsAccountTypeSelected(false);

    return setProductTypeOptions(availableProductOptions);
  };

  const handleProductTypeSelection = ({ target: { value } }) => {
    const availableAccountTypeOptions = displayAccountTypeOptions(
      accountPathType,
      value
    );
    setIsProductTypeSelected(true);
    setProductTypeOption(value);

    // set account type selected to false when product type is changed
    setIsAccountTypeSelected(false);
    return setAccountTypeOptions(availableAccountTypeOptions);
  };

  const handleAccountTypeSelection = ({ target: { value } }) => {
    setAccountTypeOption(value);
    return setIsAccountTypeSelected(true);
  };

  return (
    <>
      <div className="container">
        <div className="title-wrapper">
          <Heading text="Open a New Account" />
          <SubHeading text="Select Product and Account Type" />
        </div>
        <div className="account-option-input">
          <RadioGroupField
            title="Choose"
            options={[
              {
                title: 'Open a New Account',
                value: 'NEW ACCOUNT',
                defaultChecked: true
              },
              {
                title: 'Rollovers and Transfers',
                value: 'EXISTING ACCOUNT'
              }
            ]}
            onChange={handleAccountOption}
            name="account"
          />
        </div>
        <div className="product-type-input">
          <SelectField
            title="Select Product"
            className="product-type-options"
            {...formProps.productType}
            onChange={handleProductTypeSelection}>
            <option hidden value="">
              Select Product
            </option>
            {productTypeOptions.map(abrr => {
              return (
                <option key={abrr} value={abrr}>
                  {abrr}
                </option>
              );
            })}
          </SelectField>
        </div>
        <div className="account-type-input">
          <SelectField
            title="Select Account Type"
            className="account-type-options"
            {...formProps.accountType}
            disabled={!isProductTypeSelected}
            onChange={handleAccountTypeSelection}>
            <option hidden value="">
              Select Account
            </option>
            {accountTypeOptions.map(abrr => {
              return (
                <option key={abrr} value={abrr}>
                  {abrr}
                </option>
              );
            })}
          </SelectField>
        </div>

        <div className="additional-text">
          {isAccountTypeSelected &&
            accountPathType === accountPathTypes.EXISTING_ACCOUNT &&
            displayAdditionalText(accountTypeOption)}
        </div>
      </div>

      <div className="btn-container">
        <MFBeaconButton
          variant="primary"
          id="mfAccountFinderContinueBtn"
          data-name="mfAccountFinderContinueBtn"
          onClick={() =>
            redirectToFONASU(
              accountPathType,
              productTypeOption,
              accountTypeOption,
              bpId
            )
          }
          disabled={!(isProductTypeSelected && isAccountTypeSelected)}
          label="Continue"
        />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default MFAccountFinderScreen;
